"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var wildfires_1 = require("../../store/reducers/wildfires");
var UI_1 = require("../../store/reducers/UI");
var Search_1 = __importDefault(require("./Search"));
var SearchContainer = function () {
    var dispatch = react_redux_1.useDispatch();
    var allFeatures = react_redux_1.useSelector(wildfires_1.allFeaturesSelector);
    return (React.createElement(Search_1.default, { data: allFeatures, onChange: function (val) {
            dispatch(UI_1.searchTermChanged(val));
        } }));
};
exports.default = SearchContainer;
